var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.627 4.406a2.12 2.12 0 0 0-1.492-1.531C13.8 2.5 8.515 2.5 8.515 2.5s-5.314 0-6.65.375A2.12 2.12 0 0 0 .373 4.406C0 5.72 0 8.531 0 8.531s0 2.781.373 4.125c.186.75.777 1.313 1.492 1.5 1.336.344 6.65.344 6.65.344s5.284 0 6.62-.344a2.08 2.08 0 0 0 1.492-1.5C17 11.312 17 8.531 17 8.531s0-2.812-.373-4.125m-9.852 6.657V6l4.413 2.531z"
  })));
};
export default SvgYoutube;